import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { css, type Theme } from '@emotion/react';
import { IdentificationBadge, SignIn, ArrowSquareOut } from '@phosphor-icons/react';
import { Banner } from 'client/components/Banner';
import { Button } from 'client/components/Button';
import { DialogContent } from 'client/components/Dialog/DialogContent';
import { Divider } from 'client/components/Divider';
import { useGitHubLogin } from 'client/components/GitHub/useGitHubLogin';
import { Modal } from 'client/components/Layout/Modal';
import { Postcard } from 'client/components/Postcard';
import { LoginWithGitHubButton } from './components/LoginWithGitHubButton';

export const LoginPage = () => {
  const { search } = useLocation();
  const { login, isLoading: isGithubLoading, isError: isGithubError } = useGitHubLogin();

  const isInviteMissing = search.includes('status=unauthorized');

  useEffect(() => {
    document.title = 'Diploi - Login';
  }, []);

  return (
    <>
      <Modal>
        <DialogContent
          title="Authenticate"
          description="Sign in or register to the Diploi dashboard"
          icon={<IdentificationBadge />}
          iconOrnament={<SignIn />}
          dismissable={false}
          actions={null}
        >
          <LoginWithGitHubButton loading={isGithubLoading} onClick={() => login()} />

          {isInviteMissing && (
            <Banner type="error" css={bannerStyle}>
              Unfortunately, this GitHub account has not been invited to use Diploi at this time. If you have been invited, please contact
              the person who invited you.
            </Banner>
          )}

          {/* <Banner css={bannerStyle}>If you don't have an account yet, one will be created for you.</Banner> */}

          <Divider plain />

          <Postcard
            text={'Focus on development\nwith the DX platform\nof the future'}
            button={
              <a target="_blank" href="https://diploi.com/">
                <Button icon={<ArrowSquareOut />}>Learn more about Diploi</Button>
              </a>
            }
            open={true}
            css={postcardStyle}
          />
        </DialogContent>
      </Modal>
    </>
  );
};

const bannerStyle = css`
  margin: 16px 0;
`;

const postcardStyle = (theme: Theme) => css`
  margin: 0;
  background-color: ${theme.color.primary[60]};

  h5 > span {
    color: ${theme.color.foreground} !important;
  }
`;
